const apiHost = process.browser ? process.env.apiHostBrowser : process.env.apiHostServer;
// eslint-disable-next-line
export const VALIDATE_VULGARITY_URL = `${apiHost}/bold_all/data/censor/`;
